module.exports = __webpack_public_path__ + "img/cardActiveBgImg.b6a10a8.png";